import React, { useState, useEffect } from "react";
import FaqSection from "../components/FaqSection";
import { Helmet } from "react-helmet-async";
import styles from "./ZohoFinal.module.css"; // ✅ SAME CSS
import Navigation from "../components/Navbar";
import Footer from "../components/Footer";
import {
  Plus,
  Minus,
  ArrowRight,
  Phone,
  Mail,
  Building2,
  Shield,
  Network,
  PieChart,
  Users2,
  PlugZap,
  Database,
  Workflow,
  Package,
} from "lucide-react";

/* Assets */
// import FusionLogo from "../assests/images/fusion.png";
// import EbsLogo from "../assests/images/EBS.png";
import OeacleEBSFUSIONLogo from "../assests/images/Oracle EBS FUSION.png";

import Client1 from "../assests/images/caratlane.jpg";
import Client2 from "../assests/images/bigbasket.jpg";
import Client3 from "../assests/images/curefoods.png";
import Client4 from "../assests/images/Suguna.png";
import Client5 from "../assests/images/integra.svg";

const siteUrl = "https://www.cloudare.in/services-oracle";
const phoneDisplay = "+1 628-282-5683";
const phoneHref = "+16282825683";
const email = "sales@cloudare.in";
const calendly = "https://calendly.com/cloudare";

/* 🔥 MERGED FAQ (Fusion + OIC + EBS) */
const faqList = [
  {
    q: "What Oracle platforms do you support?",
    a: "We support Oracle Fusion ERP, Oracle Integration Cloud (OIC), and Oracle E-Business Suite (R11i, R12, R12.2).",
  },
  {
    q: "Do you provide Oracle Fusion and OIC implementations?",
    a: "Yes — we implement Oracle Fusion Financials, SCM, HCM, and OIC integrations with third-party and legacy systems.",
  },
  {
    q: "Do you provide Oracle EBS AMS and long-term support?",
    a: "Yes — we provide L2/L3 AMS, performance tuning, upgrades, and post-Premier Support services.",
  },
  {
    q: "Can Oracle EBS integrate with Oracle Fusion?",
    a: "Yes — we design hybrid architectures using OIC, REST/SOAP APIs, and SOA for EBS–Fusion coexistence.",
  },
  {
    q: "Do you support GST, e-Invoicing, and India Localization?",
    a: "Yes — across Oracle Fusion and Oracle EBS including GST, TDS, e-Invoicing, and statutory reporting.",
  },
  {
    q: "Do you handle Oracle upgrades and cloud migration?",
    a: "Yes — R11i/R12 to R12.2 upgrades, and phased migration from EBS to Oracle Fusion Cloud.",
  },
  {
    q: "Do you provide Oracle integrations with banks and SaaS platforms?",
    a: "Yes — integrations with banking systems, GST portals, Salesforce, SAP, and third-party SaaS applications.",
  },
  {
    q: "Do you offer Oracle services in India and globally?",
    a: "Yes — we serve India, KSA, US, Canada, and global enterprises.",
  },
];

export default function OracleEnterpriseServicesPage() {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <main className={styles.main}>
      <Navigation />

      <Helmet>
        <title>
          Oracle Fusion, OIC & EBS Services | Implementation & Support |
          Cloudare
        </title>
        <meta
          name="description"
          content="Oracle Fusion ERP, Oracle Integration Cloud (OIC), and Oracle E-Business Suite implementation, upgrades, integrations, and AMS services."
        />
        <link rel="canonical" href={siteUrl} />
      </Helmet>

      {/* HERO */}
      <section className={styles.hero}>
        <div className={styles.containerGrid}>
          <div className={styles.headContainer}>
            {/* <div style={{ display: "flex", gap: 16 }}> */}
            <img
              src={OeacleEBSFUSIONLogo}
              alt="Oracle EBS Fusion"
              className={styles.heroLogo}
            />
            {/* <img src={EbsLogo} alt="Oracle EBS" className={styles.heroLogo} /> */}
            {/* </div> */}

            <h1 className={styles.heroTitle1}>
              Oracle Fusion, OIC & E-Business Suite Experts
            </h1>

            <p className={styles.heroDesc}>
              End-to-end Oracle enterprise solutions covering Cloud ERP, Hybrid
              integrations, and long-term Oracle EBS support.
            </p>

            <div className={styles.heroButtons}>
              <a
                href={calendly}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.btnPrimary}
              >
                Book on Calendly <ArrowRight className={styles.iconSm} />
              </a>
              <a href="#faq" className={styles.btnSecondary}>
                View FAQs <ArrowRight className={styles.iconSm} />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className={styles.section}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>Oracle Services We Offer</h2>

          <div className={styles.appGrid}>
            <AppCard
              title="Oracle Fusion Financials"
              desc="GL, AP, AR, Assets, Tax & Compliance."
              icon={<PieChart className={styles.iconLg} />}
            />
            <AppCard
              title="Oracle Fusion HCM"
              desc="Core HR, Payroll, Talent & Workforce."
              icon={<Users2 className={styles.iconLg} />}
            />
            <AppCard
              title="Oracle Fusion SCM"
              desc="Inventory, Procurement, Order Management."
              icon={<Database className={styles.iconLg} />}
            />
            <AppCard
              title="Oracle Integration Cloud"
              desc="ERP, SaaS, REST, SOAP, File integrations."
              icon={<Network className={styles.iconLg} />}
            />
            <AppCard
              title="Oracle EBS Financials & SCM"
              desc="Finance, Manufacturing, Inventory, HRMS."
              icon={<Package className={styles.iconLg} />}
            />
            <AppCard
              title="Oracle EBS AMS & Upgrades"
              desc="R11i/R12/R12.2 support & upgrades."
              icon={<Workflow className={styles.iconLg} />}
            />
          </div>
        </div>
      </section>

      {/* WHY CHOOSE */}
      <section className={styles.sectionAlt}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>
            Why Choose Cloudare for Oracle
          </h2>

          <div className={styles.featureGrid}>
            <Feature
              icon={<Building2 className={styles.iconLg} />}
              title="Enterprise Expertise"
              desc="Cloud, on-prem, and hybrid Oracle delivery experience."
            />
            <Feature
              icon={<Shield className={styles.iconLg} />}
              title="Security & Compliance"
              desc="GST, audit controls, RBAC, and statutory compliance."
            />
            <Feature
              icon={<PlugZap className={styles.iconLg} />}
              title="Integrations & Automation"
              desc="OIC, APIs, SOA, banking, SaaS, and legacy systems."
            />
          </div>
        </div>
      </section>

      {/* CASE STUDIES */}
      <section className={styles.sectionAlt}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>Enterprise Success Stories</h2>

          <div className={styles.caseGrid}>
            <CaseStudy
              logo={Client1}
              title="Caratlane — Fusion ERP Rollout"
              points={["Multi-country rollout", "OIC integrations"]}
            />
            <CaseStudy
              logo={Client2}
              title="BigBasket — OIC Integrations"
              points={["High-volume sync", "Real-time APIs"]}
            />
            <CaseStudy
              logo={Client3}
              title="Curefoods — Fusion Integrations"
              points={["ERP sync", "Operational automation"]}
            />
            <CaseStudy
              logo={Client4}
              title="Suguna Foods — Oracle EBS"
              points={["GST compliance", "Financial automation"]}
            />
            <CaseStudy
              logo={Client5}
              title="Integra Life — SCM Optimization"
              points={["Inventory control", "Order automation"]}
            />
          </div>

          <div className={styles.statGrid}>
            <StatCard label="Oracle Projects" value="45+" maxProgress={95} />
            <StatCard
              label="Integration Accuracy"
              value="99.8%"
              maxProgress={95}
            />
            <StatCard label="Client Retention" value="100%" maxProgress={100} />
          </div>
        </div>
      </section>
      {/* CONTACT */}
      <section className={styles.section}>
        <div className={styles.container}>
          <div className={styles.contactCard}>
            <div className={styles.contact1}>
              <h2 className={styles.sectionTitle}>Talk to an Oracle Expert</h2>
              <p className={styles.heroDesc}>
                Book a free enterprise consultation.
              </p>

              <div className={styles.heroButtons}>
                <a
                  href={calendly}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.btnPrimary}
                >
                  Book on Calendly <ArrowRight className={styles.iconSm} />
                </a>
                <a href={`mailto:${email}`} className={styles.btnSecondary}>
                  <Mail className={styles.iconSm} /> {email}
                </a>
              </div>
            </div>

            <div className={styles.contactInfo}>
              <ContactRow
                label="Phone"
                value={phoneDisplay}
                href={`tel:${phoneHref}`}
                icon={<Phone />}
              />
              {/* <ContactRow
                label="Email"
                value={email}
                href={`mailto:${email}`}
                icon={<Mail />}
              /> */}
              {/* <div className={styles.locationText}>
                🌍 India • KSA • US • Canada • Global
              </div> */}
            </div>
          </div>
        </div>
      </section>

      <div id="faq">
        <FaqSection
          title="Oracle Fusion, EBS & OIC — FAQ"
          faqs={faqList.map((x) => ({ question: x.q, answer: x.a }))}
          emitJsonLd
        />
      </div>

      <Footer />
    </main>
  );
}

/* REUSED COMPONENTS */
const Feature = ({ icon, title, desc }) => (
  <div className={styles.featureCard}>
    <div className={styles.featureHeader}>
      <div className={styles.featureIcon}>{icon}</div>
      <h3 className={styles.featureTitle}>{title}</h3>
    </div>
    <p className={styles.featureDesc}>{desc}</p>
  </div>
);

const AppCard = ({ title, desc, icon }) => (
  <div className={styles.appCard}>
    <div className={styles.appHeader}>
      <div className={styles.appIcon}>{icon}</div>
      <h3 className={styles.appTitle}>{title}</h3>
    </div>
    <p className={styles.appDesc}>{desc}</p>
  </div>
);

const CaseStudy = ({ logo, title, points }) => (
  <div className={styles.caseCard}>
    <div className={styles.caseImage}>
      <img src={logo} alt={title} className={styles.caseLogo} />
    </div>
    <h3 className={styles.caseTitle}>{title}</h3>
    <ul className={styles.caseList}>
      {points.map((p, i) => (
        <li key={i}>{p}</li>
      ))}
    </ul>
  </div>
);

const StatCard = ({ label, value, maxProgress }) => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    let start = 0;
    const i = setInterval(() => {
      start += 2;
      if (start >= maxProgress) {
        start = maxProgress;
        clearInterval(i);
      }
      setProgress(start);
    }, 20);
    return () => clearInterval(i);
  }, [maxProgress]);

  const r = 45;
  const c = 2 * Math.PI * r;
  const offset = c - (progress / 100) * c;

  return (
    <div className={styles.statCard}>
      <svg className={styles.circleChart} width="100" height="100">
        <circle
          className={styles.circleBg}
          cx="50"
          cy="50"
          r={r}
          strokeWidth="10"
          fill="none"
        />
        <circle
          className={styles.circleProgress}
          cx="50"
          cy="50"
          r={r}
          strokeWidth="10"
          fill="none"
          strokeDasharray={c}
          strokeDashoffset={offset}
        />
        <text
          x="50"
          y="50"
          textAnchor="middle"
          dominantBaseline="middle"
          className="statValue"
        >
          {value}
        </text>
      </svg>
      <div className="statLabel">{label}</div>
    </div>
  );
};

const ContactRow = ({ label, value, href, icon }) => (
  <div className={styles.contactRow}>
    <div className={styles.contactIcon}>{icon}</div>
    <div>
      <div className={styles.contactLabel}>{label}</div>
      <a href={href} className={styles.contactValue}>
        {value}
      </a>
    </div>
  </div>
);
